import React, { useEffect, useState } from 'react';
import { MessageSquareHeart, X } from 'lucide-react';
import useLicenseStore from '../../store/licenseStore';
import RexPage from '../../pages/RexPage';

const API = process.env.REACT_APP_BACKEND_URL;

/** Invitation REX flottante en jeu : affichée durant les 7 derniers jours de
 *  licence ou quand l'admin a demandé un retour (`rex_requested`). */
export const RexInvite = () => {
  const { licenseKey, holderName } = useLicenseStore();
  const [status, setStatus] = useState(null);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('hst-rex-dismissed') === '1');
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (!licenseKey || dismissed) return;
    fetch(`${API}/api/feedback/rex/status?license_key=${encodeURIComponent(licenseKey)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setStatus(d); })
      .catch(() => {});
  }, [licenseKey, dismissed]);

  if (!status?.invited || dismissed || submitted) return null;

  const dismiss = () => {
    sessionStorage.setItem('hst-rex-dismissed', '1');
    setDismissed(true);
  };

  const reason = status.reasons?.includes('admin')
    ? 'Votre formateur / l\u2019équipe SCD aimerait recueillir votre retour d\u2019expérience.'
    : `Votre licence arrive à échéance${status.days_left != null && status.days_left >= 0 ? ` dans ${status.days_left} jour${status.days_left > 1 ? 's' : ''}` : ''} — c'est le moment de nous dire ce que vous avez pensé de SCD !`;

  return (
    <>
      {!open && (
        <div className="fixed bottom-4 right-4 z-[60] max-w-sm bg-card border border-accent/40 rounded-xl shadow-2xl p-4 animate-in slide-in-from-bottom-4" data-testid="rex-invite-banner">
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-full bg-accent/15 border border-accent/30 flex items-center justify-center flex-shrink-0">
              <MessageSquareHeart className="w-4.5 h-4.5 text-accent" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-bold text-foreground">Votre avis compte !</p>
              <p className="text-xs text-slate-400 mt-0.5">{reason}</p>
              <div className="flex gap-2 mt-3">
                <button onClick={() => setOpen(true)} className="px-4 py-1.5 bg-accent text-white rounded-full text-xs font-bold hover:bg-accent-hover" data-testid="rex-invite-open">
                  Donner mon retour
                </button>
                <button onClick={dismiss} className="px-3 py-1.5 text-xs text-slate-500 hover:text-slate-300" data-testid="rex-invite-later">
                  Plus tard
                </button>
              </div>
            </div>
            <button onClick={dismiss} className="p-1 text-slate-600 hover:text-slate-400" data-testid="rex-invite-dismiss">
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      {open && (
        <div className="fixed inset-0 z-[70] bg-black/70 flex items-start justify-center overflow-y-auto py-8" data-testid="rex-modal">
          <div className="bg-card border border-ink-600 rounded-xl w-full max-w-2xl mx-4">
            <RexPage
              licenseKey={licenseKey}
              holderName={holderName}
              onClose={() => setOpen(false)}
              onSubmitted={() => setSubmitted(true)}
            />
          </div>
        </div>
      )}
    </>
  );
};
